export const API_BASE_URL = 'https://api.dresskids.es';
export const API_URL = `${API_BASE_URL}/api`;
export const TOKEN_ENDPOINT = `${API_BASE_URL}/authentication_token`;
export const API_IMAGES_URL = `${API_BASE_URL}/uploads/images`;
export const PATH_PAGINA_INICIO = '/';
